import { Component } from '@angular/core';

@Component({
  selector: 'not-found-page',
  templateUrl: './console/app-js/shared/pages/not-found-page.component.html'
})
export class NotFoundPageComponent {
  protected message: string;
}
